module.exports = __webpack_public_path__ + "static/img/const-content-3.57e11b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/const-content-3.png
// module id = PNbR
// module chunks = 0